<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-subtitle>
        <v-icon class="mr-1">email</v-icon>
        Email Address
      </v-list-item-subtitle>
      <v-list-item-title>{{ emailProp === '  ' ? '...' : emailProp }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: {
    email: String
  },
  data: function () {
    return {
      showEditView: false,
      enableSave: false
    }
  },
  methods: {
  },
  computed: {
    emailProp: function () {
      return this.email
    }
  },
  watch: {
    emailProp: function () {
      this.emailUpdate = JSON.parse(JSON.stringify(this.email))
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Profile/email.vue